/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateEmailDataSchema = z.object({
	id: z.string(),
	candidateId: z.string(),
	userId: z.string().nullable(),
	senderName: z.string().nullable(),
	senderEmail: z.string().nullable(),
	subject: z.string().nullable(),
	body: z.string(),
	direction: z.string(),
	messageId: z.string().nullable(),
	sentAt: z.iso.datetime().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	isRead: z.boolean(),
	readAt: z.iso.datetime().nullable(),
	readBy: z.array(z.object({ userId: z.string(), readAt: z.iso.datetime().nullable() })),
	attachments: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			size: z.number(),
			type: z.string().nullable(),
			url: z.string().nullable(),
			scanStatus: z.union([
				z.literal('queued'),
				z.literal('scanning'),
				z.literal('clean'),
				z.literal('infected'),
				z.literal('error'),
				z.literal('skipped'),
			]).nullable(),
			scanSignature: z.string().nullable(),
		}),
	),
})

export type CandidateEmailDataSchema = z.infer<typeof candidateEmailDataSchema>
